import Swiper from 'swiper';

class SliderPromoteJob {
  public component;
  public trigger;
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="slider-promote-job"]'
    );
    this.trigger = document.querySelectorAll(
      '[data-trigger="slider-promote-job"]'
    );
    if (this.component && this.trigger) {
      this._init();
    }
  }
  _init() {
    this.trigger.forEach((element) => {
      let mySwiper: any = null;

      const firstImage = element.querySelector('img');
      if (firstImage) {
        firstImage.onload = () => {
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        spaceBetween: 15,
        preventClicks: true,
        watchOverflow: true,
        slidesPerView: 'auto',
        freeMode: true
      });
    });
  }
}

export const sliderPromoteJob = new SliderPromoteJob();
